module.exports = __webpack_public_path__ + "img/image02_sp.c6e4e40b.jpg";